import { memo, useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";
import { getFirstDayOfMonth } from "@/lib/dayjs/get-first-day-of-month";

import ArrowRight from "@/components/ui/icon/arrow-right";

import { useCalender } from "../../../context/calendar/calendar-context";

type Props = {
	currentMonthFirstDay: string;
	onSetPreviousMonth: () => void;
	className?: string;
};

export const PrevMonth = memo(({ currentMonthFirstDay, onSetPreviousMonth, className }: Props) => {
	const { hideYear, canSelectPastDate } = useCalender();

	const isPastMonth = (() => {
		if (hideYear || canSelectPastDate) {
			return false;
		} else {
			return getFirstDayOfMonth({}) === getFirstDayOfMonth({ date: currentMonthFirstDay });
		}
	})();

	const disabled = isPastMonth;

	const handleClick = useCallback(() => {
		onSetPreviousMonth();
	}, [onSetPreviousMonth]);

	return (
		<button
			onClick={handleClick}
			disabled={disabled}
			className={cn(
				"rounded bg-white p-2 text-center hover:bg-zinc-100", //
				disabled && "pointer-events-none text-zinc-300",
				className,
			)}
		>
			<ArrowRight className="h-[18px] w-[18px] rotate-180" />
		</button>
	);
});

PrevMonth.displayName = "PrevMonth";
